export const PAYMENT_MODES = [
  { value: 'especes', label: 'Espèces' },
  { value: 'cheque', label: 'Chèque' },
  { value: 'traite', label: 'Traite' },
  { value: 'virement', label: 'Virement' },
  { value: 'versement_bancaire', label: 'Versement bancaire' },
  { value: 'carte', label: 'Carte' },
  { value: 'autre', label: 'Autre' }
];

export const PAYMENT_MODE_LABELS = {
  especes: 'Espèces',
  cheque: 'Chèque',
  traite: 'Traite',
  virement: 'Virement',
  versement_bancaire: 'Versement bancaire',
  carte: 'Carte',
  autre: 'Autre'
};

export const getPaymentModeLabel = (mode) => {
  if (!mode) return 'Espèces';
  return PAYMENT_MODE_LABELS[mode] || mode;
};
